const SERVICE_NAME = 'ipgeolocation';
import backend from '@/lib/backend';
export default axios => ({
  get() {
    return backend(axios, SERVICE_NAME).find();
  }
});
